import { PropsWithChildren, ReactNode } from "react"
import { classNames } from "../../style/common"

export type ColumnLabelProps = PropsWithChildren & {
    label: ReactNode,
    classNames?: {
        container?: string,
        column1?: string,
        column2?: string
    }
}

export function ColumnLabel(props: ColumnLabelProps) {
    return (
        <div className={classNames(`flex flex-col 2xl:grid 2xl:grid-cols-[100px_1fr] 2xl:gap-6 gap-1 select-none`, props?.classNames?.container)}>
            <div className="text-sm/6 font-medium flex items-start 2xl:justify-end 2xl:pt-1">
                <div className="text-right justify-end">{props.label}</div>
            </div>
            <div className={classNames("", props?.classNames?.column2)}>
                {props.children}
            </div>
        </div>
    )
}